import { c as _c } from "react/compiler-runtime";
import type { Option } from '@newfront-insurance/core-ui';
import { SelectInput } from '@newfront-insurance/core-ui';
import { useEffect, useState, type JSX } from 'react';
import * as React from 'react';
interface Props {
  value?: string;
  onChange: (countryCode: string) => unknown;
  disabled?: boolean;
  name?: string;
  innerRef?: React.MutableRefObject<HTMLSelectElement>;
  placeholder?: string;
  testId?: string;
}
export interface Country {
  country_name_en: string;
  alpha3: string;
}
async function getCountriesOptions(): Promise<Option[]> {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const countriesQuery = await import('countries-code');
  const options: Option[] = countriesQuery.allCountriesList().map((country: Country) => ({
    label: country.country_name_en,
    value: country.alpha3
  }));
  return options;
}
export function CountryCodeSelect(t0) {
  const $ = _c(14);
  const {
    name,
    onChange,
    value,
    innerRef,
    disabled,
    placeholder: t1,
    testId
  } = t0;
  const placeholder = t1 === undefined ? "Select country" : t1;
  const [options, setOptions] = useState();
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      getCountriesOptions().then(countries => setOptions(countries));
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] !== options) {
    t4 = options || [];
    $[2] = options;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = !value;
  let t6;
  if ($[4] !== disabled || $[5] !== innerRef || $[6] !== name || $[7] !== onChange || $[8] !== placeholder || $[9] !== t4 || $[10] !== t5 || $[11] !== testId || $[12] !== value) {
    t6 = <div><SelectInput name={name} options={t4} onChange={onChange} showSelectAnOption={t5} placeholder={placeholder} value={value} innerRef={innerRef} disabled={disabled} testId={testId} /></div>;
    $[4] = disabled;
    $[5] = innerRef;
    $[6] = name;
    $[7] = onChange;
    $[8] = placeholder;
    $[9] = t4;
    $[10] = t5;
    $[11] = testId;
    $[12] = value;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}